import { HttpLink } from 'apollo-link-http'
import { apiHost, appId } from '../constants'

const link: any = new HttpLink({
	uri: `${apiHost}/graphql`,
	headers: {
		AppId: appId
	}
})
export default link
